import FieldAffix from './FieldAffix.vue';
import FieldCategory from './FieldCategory.vue';
import FieldCheckbox from './FieldCheckbox.vue';
import FieldChoice from './FieldChoice.vue';
import FieldCondition from './FieldCondition.vue';
import FieldDateTime from './FieldDateTime.vue';
import FieldEditor from './FieldEditor.vue';
import FieldError from './FieldError.vue';
import FieldMinMax from './FieldMinMax.vue';
import FieldName from './FieldName.vue';
import FieldNumeric from './FieldNumeric.vue';
import FieldOptions from './FieldOptions.vue';
import FieldPeriod from './FieldPeriod.vue';
import FieldRadioList from './FieldRadioList.vue';
import FieldReadonly from './FieldReadonly.vue';
import FieldRequired from './FieldRequired.vue';
import FieldSelect from './FieldSelect.vue';
import FieldText from './FieldText.vue';
import FieldTextarea from './FieldTextarea.vue';
import FieldVisible from './FieldVisible.vue';

export {
    FieldAffix,
    FieldCategory,
    FieldCheckbox,
    FieldChoice,
    FieldCondition,
    FieldDateTime,
    FieldEditor,
    FieldError,
    FieldMinMax,
    FieldName,
    FieldNumeric,
    FieldOptions,
    FieldPeriod,
    FieldRadioList,
    FieldReadonly,
    FieldRequired,
    FieldSelect,
    FieldText,
    FieldTextarea,
    FieldVisible
};

export default {
    'field-affix': FieldAffix,
    'field-category': FieldCategory,
    'field-checkbox': FieldCheckbox,
    'field-choice': FieldChoice,
    'field-condition': FieldCondition,
    'field-datetime': FieldDateTime,
    'field-editor': FieldEditor,
    'field-error': FieldError,
    'field-minmax': FieldMinMax,
    'field-name': FieldName,
    'field-numeric': FieldNumeric,
    'field-options': FieldOptions,
    'field-period': FieldPeriod,
    'field-radio': FieldRadioList,
    'field-readonly': FieldReadonly,
    'field-required': FieldRequired,
    'field-select': FieldSelect,
    'field-text': FieldText,
    'field-textarea': FieldTextarea,
    'field-visible': FieldVisible
};
